module.exports = "pegasus_template/assets/gray-ghost-facebook.png";